/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import { Injectable, Inject } from "@angular/core";
import { ServiceConfig } from "./core.constants";

@Injectable()
export class WorkScheduleMustersDataService { 

    private $http: ng.IHttpService;
    private musterShipUrl = ServiceConfig.webApiUrl + "MusterShip/MusterPost";

    constructor( @Inject("$http") $http: ng.IHttpService) {
        this.$http = $http;
    }

    public musterShip(musterShipParams: MusterShipParams): ng.IPromise<Nema.Crew.Model.Activity[]> {
        return this.$http
            .post(this.musterShipUrl, JSON.stringify(musterShipParams))
            .then(responce => <Nema.Crew.Model.Activity[]>responce.data);
    }
}

export interface MusterShipParams {
    WorkPlaceId: number;
    WorkSheduleTemplateId: number;
    PersonIds: number[];
    StartDate: Date;
    EndDate: Date;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/workschedulemustersdataservice.ts